import { useParams } from 'react-router';
import { useEffect, useState } from 'react';
import buskwarehousedetail from '../services/buskwarehousedetail';
import { stateKorea } from '../../utils/Languages';
import ReturnDisposalListHead from '../components/ReturnDisposalListHead';
import ReturnDisposalListTable from '../components/table/ReturnDisposalListTable';

const ReturnDisposalList = () => {
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  // return
  const [returnsCount, setReturnsCount] = useState(0);
  const [returnsRowData, setReturnsRowData] = useState();
  const [selectedReturns, setSelectedReturns] = useState<React.Key[]>([]);

  const getReturns = async (id: string, page: number) => {
    setLoading(true);
    const data = await buskwarehousedetail.getReturn(id, page);
    const rowDataModified = data.data?.map((r: any, index: number) => {
      return {
        ...r,
        key: r.id,
        // no: index + (page - 1) * 10 + 1,
        no: r.id,
        state: stateKorea(r.state)
      };
    });
    setReturnsRowData(rowDataModified);
    setReturnsCount(data.count);
    setLoading(false);
  };

  useEffect(() => {
    getReturns(id, page);
  }, [id, page]);

  return (
    <>
      <ReturnDisposalListHead
        totalReturns={returnsCount}
        selectedReturns={selectedReturns}
      />
      <ReturnDisposalListTable
        loading={loading}
        getReturns={getReturns}
        totalReturns={returnsCount}
        returnsRowData={returnsRowData}
        selectedReturns={selectedReturns}
        setSelectedReturns={setSelectedReturns}
      />
    </>
  );
};

export default ReturnDisposalList;
